import { useEffect, useState } from 'react';
import { useAppSelector } from '@src/core/hooks';
import { decideAuthOutcome, AUTH_MODE, AUTH_OUTCOME } from '@src/domains/customers';
import {
  buyerSelector,
  createdAccountSelector,
  modifiedPasswordSelector,
  setupAuthOngoingSelector,
} from '@src/features/customers/auth/store/auth';

export function useAuthFlow(onLogin?: () => void) {
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState<string>(AUTH_MODE.LOGIN);

  const [, logged] = useAppSelector(buyerSelector);
  const accountCreated = useAppSelector(createdAccountSelector);
  const modifiedPassword = useAppSelector(modifiedPasswordSelector);
  const setupAuthOngoing = useAppSelector(setupAuthOngoingSelector);

  useEffect(() => {
    const outcome = decideAuthOutcome({ logged: Boolean(logged) });

    if (outcome.type === AUTH_OUTCOME.COMPLETED && onLogin) onLogin();

    if (mode && !setupAuthOngoing && loading) {
      setLoading(false);
    }
    // `accountCreated` and `modifiedPassword` aren't read in the body but stay in
    // the deps on purpose: they are what re-runs the effect once signup or password
    // reset completes. Removing them changes behavior.
  }, [logged, accountCreated, modifiedPassword, setupAuthOngoing]);

  return { mode, setMode, loading };
}
